import { requiredStrategy } from '../core';
import { microElectricBikePlateNumberFormatStrategy } from './micro-electric-bike-plate-number-format-strategy';

export const microElectricBikePlateNumberStrategy = (value: string) =>
  requiredStrategy(value) && microElectricBikePlateNumberFormatStrategy(value);
